export const THEME = [
  'linear-gradient(90deg, #5270fc, #5270fc 100%, #ffffff)',
  'linear-gradient(90deg, #fc9e19, #fc9e19 100%, #ffffff)',
  'linear-gradient(90deg, #002d75, #002d75 100%, #ffffff)',
  'linear-gradient(90deg, #00bdab, #00bdab 100%, #ffffff)',
  'linear-gradient(90deg, #7c2ae8, #7c2ae8 100%, #ffffff)',
  'linear-gradient(90deg, #05c1c9, #05c1c9 100%, #ffffff)',
  'linear-gradient(90deg, #ff6347, #ff6347 100%, #ffffff)',
  'linear-gradient(90deg, #3cb371, #3cb371 100%, #ffffff)',
  'linear-gradient(90deg, #8a0309, #8a0309 100%, #ffffff)',
  'linear-gradient(90deg, #ee82ee, #ee82ee 100%, #ffffff)',
  'linear-gradient(90deg, #ff0000, #ff0000 100%, #ffffff)',
  'linear-gradient(90deg, #ffc0cb, #ffc0cb 100%, #ffffff)',
];

import { find, get } from 'lodash';
import {
  IMG_7574,
  IMG_7575,
  IMG_7576,
  IMG_7577,
  IMG_7595,
  IMG_7596,
  IMG_7600,
  IMG_7605,
  IMG_7611,
  IMG_7614,
} from 'utils/assets/images';

export const AVATARS = [
  IMG_7614,
  IMG_7611,
  IMG_7605,
  IMG_7600,
  IMG_7574,
  IMG_7575,
  IMG_7576,
  IMG_7577,
  IMG_7595,
  IMG_7596,
];
export const CLASS_AVATARS = {
  IMG_7614,
  IMG_7611,
  IMG_7605,
  IMG_7600,
  IMG_7574,
  IMG_7575,
  IMG_7576,
  IMG_7577,
  IMG_7595,
  IMG_7596,
}
export const dummyPicture = `https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FdummyPicture.png?alt=media&token=1354d5b3-b159-401e-aac8-122e76009c06`

export const getClassAvatar = (classId,classes) => {
  const classInfo = find(classes,['id',classId]);
  const cls_avatar = get(classInfo, "config.avatar", '')
  return CLASS_AVATARS[cls_avatar] ? CLASS_AVATARS[cls_avatar] : dummyPicture;
}